<template>
    <v-container class="pa-12 fill-height align-start" fluid>
        <v-row>
            <v-col cols="12" lg="7">
                <v-card flat color="grey lighten-4" class="px-4" height="100%">
                    <div class="title pt-2">Users</div>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-4">
                                    <div>
                                        <v-avatar tile color="primary">
                                            <v-icon color="white">mdi-account</v-icon>
                                        </v-avatar>
                                        <span class="overline font-weight-medium mx-2">Active users</span>
                                    </div>
                                    <span class="primary--text font-weight-bold" v-text="totalActiveUsers"></span>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">mentors</div>
                                    <div class="font-weight-bold subtitle-1" v-text="activeTutors"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">parents</div>
                                    <div class="font-weight-bold subtitle-1" v-text="activeParents"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">Students</div>
                                    <div class="font-weight-bold subtitle-1" v-text="activeStudents"></div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-4">
                                    <div>
                                        <v-avatar tile color="warning">
                                            <v-icon color="white">mdi-account-off</v-icon>
                                        </v-avatar>
                                        <span class="overline font-weight-medium mx-2">Deactivated users</span>
                                    </div>
                                    <span class="warning--text font-weight-bold" v-text="deactivatedUsers"></span>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">mentors</div>
                                    <div class="font-weight-bold subtitle-1" v-text="deactivatedTutors"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">parents</div>
                                    <div class="font-weight-bold subtitle-1" v-text="deactivatedParents"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">Students</div>
                                    <div class="font-weight-bold subtitle-1" v-text="deactivatedStudents"></div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-4">
                                    <div>
                                        <v-avatar tile color="secondary">
                                            <v-icon color="white">mdi-account-remove</v-icon>
                                        </v-avatar>
                                        <span class="overline font-weight-medium mx-2">Deleted users</span>
                                    </div>
                                    <span class="secondary--text font-weight-bold">0</span>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">mentors</div>
                                    <div class="font-weight-bold subtitle-1">0</div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">parents</div>
                                    <div class="font-weight-bold subtitle-1">0</div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">Students</div>
                                    <div class="font-weight-bold subtitle-1">0</div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" lg="5">
                <v-card flat color="grey lighten-4" class="px-4" height="100%">
                    <div class="d-flex align-center justify-space-between pt-2">
                        <div class="title">Subscriptions</div>
                        <!-- <div class="title">Revenue $2,500</div> -->
                    </div>
                    <v-row>
                        <v-col cols="12" md="6" lg="6">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-4">
                                    <div>
                                        <v-avatar color="success" tile>
                                            <v-icon color="white">mdi-currency-usd</v-icon>
                                        </v-avatar>
                                        <span class="overline font-weight-medium mx-2">Active subscriptions</span>
                                    </div>
                                    <span class="success--text font-weight-bold" v-text="totalSubscriptions"></span>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">monthly</div>
                                    <div class="font-weight-bold subtitle-1" v-text="monthlySubscriptions"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">annual</div>
                                    <div class="font-weight-bold subtitle-1" v-text="annualSubscriptions"></div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" lg="6">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-4">
                                    <div>
                                        <v-avatar tile color="secondary">
                                            <v-icon color="white">mdi-currency-usd-off</v-icon>
                                        </v-avatar>
                                        <span class="overline font-weight-medium mx-2">Canceled subscriptions</span>
                                    </div>
                                    <span class="secondary--text font-weight-bold">{{ cancelledAnnualSubscriptions + cancelledMonthlySubscriptions }}</span>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">monthly</div>
                                    <div class="font-weight-bold subtitle-1" v-text="cancelledMonthlySubscriptions"></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="d-flex align-center justify-space-between py-1 px-2">
                                    <div class="overline">annual</div>
                                    <div class="font-weight-bold subtitle-1" v-text="cancelledAnnualSubscriptions"></div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card flat color="grey lighten-4" class="px-4" height="100%">
                    <div class="d-flex align-center justify-space-between pt-2">
                        <div class="title">Sessions {{ totalSessions }}</div>
                        <div class="title">Revenue ${{ countRevenueOfSessions }}</div>
                    </div>
                    <v-row>
                        <v-col cols="12" md="4" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Upcoming</span>
                                    <v-avatar color="success" tile>
                                        <span class="white--text title" v-text="upcomingSessions"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Past</span>
                                    <v-avatar tile color="grey">
                                        <span class="white--text title" v-text="pastSessions"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Canceled</span>
                                    <v-avatar tile color="secondary">
                                        <span class="white--text title" v-text="cancelledSessions"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" lg="6">
                <v-card flat color="grey lighten-4" height="100%">
                    <div class="d-flex align-center justify-space-between px-4 pt-2">
                        <div class="title">E-Creative</div>
                        <div class="title">Granted prizes: ${{ grantedPrizes }}</div>
                    </div>
                    <v-row class="px-4">
                        <v-col cols="12" md="6" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Open projects</span>
                                    <v-avatar tile color="teal">
                                        <span class="white--text title" v-text="openProjectsCount"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Received bids</span>
                                    <v-avatar tile color="deep-orange">
                                        <span class="white--text title" v-text="receivedBids"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" lg="4">
                            <v-card outlined>
                                <div class="d-flex align-center justify-space-between pa-1 pr-1">
                                    <span class="overline font-weight-medium mx-2">Winners</span>
                                    <v-avatar tile color="deep-purple">
                                        <span class="white--text title" v-text="numberOfWinners"></span>
                                    </v-avatar>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'statistics',
        data: () => ({
            activeStudents: 0,
            activeTutors: 0,
            annualSubscriptions: 0,
            monthlySubscriptions: 0,
            numberOfWinners: 0,
            numberOfOpenProjects: 0,
            receivedBids: 0,
            totalActiveUsers: 0,
            totalSessions: 0,
            totalSubscriptions: 0,
            activeAdministrators: 0,
            activeCrowdsources: 0,
            activeParents: 0,
            activeStudents: 0,
            activeTutors: 0,
            annualPriceSubscriptions: 0,
            annualSubscriptions: 0,
            cancelledAnnualSubscriptions: 0,
            cancelledMonthlySubscriptions: 0,
            cancelledSessions: 0,
            countRevenueOfSessions: 0,
            deactivatedParents: 0,
            deactivatedStudents: 0,
            deactivatedTutors: 0,
            deactivatedUsers: 0,
            grantedPrizes: 0,
            monthlyPriceSubscriptions: 0,
            monthlySubscriptions: 0,
            numberOfWinners: 0,
            openProjectsCount: 0,
            pastSessions: 0,
            receivedBids: 0,
            totalActiveUsers: 0,
            totalSessions: 0,
            totalSubscriptions: 0,
            upcomingSessions: 0,
            loading: true
        }),
        computed: {
            ...mapGetters(['defaultLanguage']),
        },
        mounted() {
            this.fetchStatistics()
        },
        methods: {
            async fetchStatistics() {
                await this.axios.get(`User/DashboardStatistics?languageId=${this.defaultLanguage.id}`)
                .then(response => {
                    this.numberOfOpenProjects = response.data.open_projects_count
                    this.receivedBids = response.data.received_bids
                    this.totalActiveUsers = response.data.total_active_users
                    this.totalSessions = response.data.total_sessions
                    this.totalSubscriptions = response.data.total_subscriptions
                    this.activeAdministrators = response.data.active_administrators
                    this.activeCrowdsources = response.data.active_crowdsources
                    this.activeParents = response.data.active_parents
                    this.activeStudents = response.data.active_students
                    this.activeTutors = response.data.active_tutors
                    this.annualPriceSubscriptions = response.data.annual_price_subscriptions
                    this.annualSubscriptions = response.data.annual_subscriptions
                    this.cancelledAnnualSubscriptions = response.data.cancelled_annual_subscriptions
                    this.cancelledMonthlySubscriptions = response.data.cancelled_monthly_subscriptions
                    this.cancelledSessions = response.data.cancelled_sessions
                    this.countRevenueOfSessions = response.data.count_revenue_of_sessions
                    this.deactivatedParents = response.data.deactivated_parents
                    this.deactivatedStudents = response.data.deactivated_students
                    this.deactivatedTutors = response.data.deactivated_tutors
                    this.deactivatedUsers = response.data.deactivated_users
                    this.grantedPrizes = response.data.granted_prizes
                    this.monthlyPriceSubscriptions = response.data.monthly_price_subscriptions
                    this.monthlySubscriptions = response.data.monthly_subscriptions
                    this.numberOfWinners = response.data.number_of_winners
                    this.openProjectsCount = response.data.open_projects_count
                    this.pastSessions = response.data.past_sessions
                    this.upcomingSessions = response.data.upcoming_sessions
                    this.loading = false
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>